module.exports = __webpack_public_path__ + "static/media/aoxferulic.df32eb4b.png";